<template>
  <div>
    <div class="card" :class="{ 'mix-red': data.statusTypeId === 14, 'red': data.statusTypeId === 12 }">
      <div class="card-body">
        <div class="card-title">
          <div class="d-flex align-items-center justify-content-between">
            <div class="d-flex align-items-center">
              <status-label
                :type="data.statusTypeId === 5 ? 'orange' : '' || data.statusTypeId === 14 ? 'mixred' : '' || data.statusTypeId === 10 ? 'green' : '' || data.statusTypeId === 12 ? 'red' : ''" />
              <span class="status-text-card">{{ data.statusTypeName }}</span>
            </div>
            <div class="d-flex align-items-center">
              <el-button v-if="isAccidentOld" title="Gec məlumat" style="padding: 0 !important; margin-right: 5px"
                size="medium">
                <div class="comm-icon" style="color: red;">
                  <i class="fa-solid fa-exclamation"></i>
                </div>
              </el-button>
              <span class="accident-icon">
                <router-link :to="`/accident/${data.id}`" style=" font-size: var(--font-medium);"># {{
                  data.dispAccidentNumber }}</router-link> </span>
            </div>
          </div>
        </div>

        <div class="card-text">
          <span class="info-text">
            <span class="info-label">{{$t('Sığorta_növü')}}:</span>
            {{ data.policyTypeName }}
          </span>
          <br>
          <span class="info-text"><span class="info-label">{{$t('Sürücü')}}:</span> </span>
          <span class="info-text" v-if="data.driver">{{ data.driver }}</span>
          <span class="info-text no-data" v-else>{{ $t('Məlumat_yoxdur') }}</span>
          <br />
          <span class="info-text" v-if="data.driver">
            <span class="info-label">{{ data.driverPhone ? $t('Sürücü_nömrəsi') + ': ' : $t('Məlumat_olmama_səbəbi') +
              ': ' }}</span>
            <span> {{ data.driverPhone ? data.driverPhone : data.driverDescr }}</span>
          </span>
          <span class="info-text x-small" v-else>
            <span class="info-label x-small">{{ $t('Məlumat_olmama_səbəbi') }}:</span> {{ data.driverDescr }}
          </span>
          <br />
          <span class="info-text small">{{ data.brandModel ? (data.brandModel + ',') : '' }} {{ data.regNumber }}</span>
          <br />
          <span class="info-text x-small"><span class="info-label x-small">{{$t('Hadisə_tarixi')}}:</span> <span
              class="info-text small">{{ data.accidentDateStr }}</span></span>
          <br />
          <span class="info-text x-small"><span class="info-label x-small">{{$t('Hadisə_yeri')}}:</span><span
              class="info-text small"> {{ data.place }}</span></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import { DateToString } from "../../services/helper";
  import StatusLabel from "../components/StatusLabel.vue";

  export default {
    components: { StatusLabel },
    props: {
      item: Object,
    },
    data() {
      return {
        data: this.item,
        statusCount: 0,
        showModal: false,
      };
    },

    computed: {
      isAccidentOld() {
        const twentyFourHours = 24 * 60 * 60 * 1000;
        const accidentDate = new Date(this.data.accidentDateStr.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$2/$1/$3"));
        const callDate = new Date(this.data.callDate.replace(/(\d{2})\.(\d{2})\.(\d{4})/, "$2/$1/$3"));
        const timeDifference = callDate.getTime() - accidentDate.getTime();
        return timeDifference >= twentyFourHours;
      }
    },

    methods: {
      handleCommand(command) {
        let id = command.id;
        if (command.action === "comm") this.handleComm(command.id);
      },
      handleComm(id) {
        this.checkStatusCount(id).then(() => {
          if (this.statusCount > 0) {
            this.$message({
              type: "warning",
              message: "Daha öncə Müştəri xidmətinə göndərilib",
            });
          }
          else {
            this.$emit("send", id);
          }
        });
      },
      handleDelete(id) { },
      checkStatusCount(id) {
        this.statusCount = 0;
        return new Promise((resolve, reject) => {
          CheckStatusCount(id, 0, 30).then((response) => {
            if (response.data) {
              this.statusCount = response.data;
            }
            resolve(this.response);
          }, error => {
            reject(error);
          })
        })
      },
    },
    watch: {
      item() {
        this.data = this.item;
      },
    },
    mounted() {
    },
  };
</script>

<style>
  .progress {
    background-color: #fbfaf9;
  }

  .new {
    background-color: #ddf8f8;
  }

  .started {
    background-color: #a6f7cd;
  }

  .forward {
    background-color: #c1b7bc;
  }

  .mix-red {
    border: 1px solid #B3005E;
  }

  .red {
    border: 1px solid red;
  }

  /* Text styles */
  .status-text-card {
    margin-left: 8px;
    font-size: var(--font-medium);
    font-weight: bold;
    color: #3A3A3A;
  }

  .info-text {
    font-size: var(--font-medium);
  }

  .small {
    font-size: var(--font-medium);
  }

  .x-small {
    font-size: var(--font-primary);
  }

  .info-label {
    font-weight: bold;
    color: #3A3A3A;
  }

  .no-data {
    color: red;
    font-weight: bold;
  }


  .comm-icon {
    color: red;
  }
</style>